import type { FieldDef } from '../types'

export function buildFormDefaultValues(fields: FieldDef[]): Record<string, unknown> {
  return fields.reduce<Record<string, unknown>>((acc, field) => ({
    ...acc,
    [field.name]: field.type === 'checkbox' ? (field.defaultValue ?? false) : (field.defaultValue ?? ''),
  }), {})
}
